import * as React from 'react';

const SvgIcnGlobal = (props) => (
  <svg viewBox="0 0 17 17" fill="none" role="img" {...props}>
    <path
      d="M8.32 0.0199997C12.92 0.0199997 16.66 3.76 16.66 8.36C16.66 12.96 12.92 16.7 8.32 16.7C3.72 16.7 1.49012e-08 12.96 1.49012e-08 8.36C1.49012e-08 3.76 3.72 0.0199997 8.32 0.0199997ZM15.04 7.58C14.72 4.8 12.72 2.54 10.1 1.84C11.22 3.54 11.9 5.52 12.08 7.58H15.04ZM6.14 9.14C6.32 11.16 7.08 13.08 8.32 14.7C9.56 13.1 10.32 11.16 10.52 9.14H6.14ZM6.14 7.58H10.52C10.32 5.56 9.56 3.64 8.32 2.02C7.08 3.62 6.32 5.56 6.14 7.58ZM6.56 1.84C3.92 2.54 1.92 4.8 1.6 7.58H4.58C4.74 5.52 5.44 3.54 6.56 1.84ZM1.6 9.14C1.92 11.92 3.92 14.18 6.56 14.88C5.42 13.18 4.74 11.2 4.58 9.14H1.6ZM10.1 14.88C12.72 14.18 14.72 11.92 15.04 9.14H12.08C11.9 11.22 11.22 13.18 10.1 14.88Z"
      fill="white"
    />
  </svg>
);
export default SvgIcnGlobal;
